import mergeOptions from '../utils/mergeOptions';
import { serialize } from '../utils/browser';
import { HaEncrypt } from '../ha-crypto';
const Crypto = new HaEncrypt()

//@ts-check
const minFetch = (config) => {
    let headers = { 'content-type': 'application/x-www-form-urlencoded', encryption: 2 }
    const zsbtoken = Crypto.JSCrypto.getToken('zsbtoken')
    if (zsbtoken) headers.zsbtoken = zsbtoken;
    config = mergeOptions({
        method: 'get',
        success: function () { },
        headers,
        error: function () { }
    }, config);
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        var status = xhr.status;
        if (xhr.readyState == 4) {
            if (status >= 200&&status<300) {
                let text = xhr.response;
                try { 
                    text = JSON.parse(text) 
                } catch (error) {

                };
                config.success(Crypto.decrypt(text, config.headers));
            }else{
                config.error('error');
            }
        }
    }
    if (config.params) {
        let { option, headers } = Crypto.encrypt(config.params, config.headers);
        config.headers = headers;
        if (option.hasOwnProperty('requestData')) {
            option.requestData = encodeURIComponent(option.requestData)
        }
        if (config.url.indexOf('?') > -1) {
            config.url = (config.url) + "&" + (serialize(option));
        } else {
            config.url = (config.url) + "?" + (serialize(option));
        }
    }
    xhr.open(config.method, config.url);

    if (config.data) {
        let { option, headers } = Crypto.encrypt(config.data, config.headers)
        if (option.hasOwnProperty('requestData')) {
            option.requestData = encodeURIComponent(option.requestData)
        }
        config.headers = headers
        let contentType = config.headers['Content-type'] || config.headers['content-type'] || '';
        config.data = !!~contentType.indexOf("application/json") ? JSON.stringify(config.data) : serialize(option);
    }
    for(var v in config.headers){
        xhr.setRequestHeader(v,config.headers[v]);
    }
    xhr.send(config.data);
}

export default minFetch